<div *ngIf="srcIcon" fxLayoutAlign="center center" class="img-icon">
    <img [src]="srcIcon"/>
</div>

<div *ngIf="matIcon" fxLayoutAlign="center center">
    <mat-icon>{{matIcon}}</mat-icon>
</div>

<fa-icon *ngIf="faIcon" [icon]="faIcon"></fa-icon>